"use client";

import Link from "next/link";
import { useContext } from "react";
import { AppContext } from "@/context/AppContext";

export default function Navigation() {
  const { activePage, isOnCvSubdomain } = useContext(AppContext);

  // Diese Funktion fügt die Domain hinzu, wenn wir auf der CV-Subdomain sind
  const getHref = (path: string): string => {
    if (isOnCvSubdomain) {
      return `https://robinwichmann.com${path}`;
    }
    return path;
  };

  return (
    <div className={`wrapper wrapper--top ${activePage}-page`}>
      <nav className="navigation">
        <div className="navigation--frame">
          <div className="navigation--container">
            <nav>
              <Link 
                href={getHref("/")} 
                className={`navigation--link no-select ${activePage === 'home' ? 'router-link-active' : ''}`}
                style={activePage === 'home' ? { color: '#88ffff' } : {}}
              >
                Home
              </Link>
              <Link 
                href={getHref("/about")} 
                className={`navigation--link no-select ${activePage === 'about' ? 'router-link-active' : ''}`}
                style={activePage === 'about' ? { color: '#88ff88' } : {}}
              >
                About
              </Link>
              <Link 
                href={getHref("/work")} 
                className={`navigation--link no-select ${activePage === 'work' ? 'router-link-active' : ''}`}
                style={activePage === 'work' ? { color: '#ff88ff' } : {}}
              >
                Work
              </Link>
              <Link 
                href={getHref("/contact")} 
                className={`navigation--link no-select ${activePage === 'contact' ? 'router-link-active' : ''}`}
                style={activePage === 'contact' ? { color: '#ff8855' } : {}}
              >
                Contact
              </Link>
              
              {/* CV-Menüpunkt - nur auf der CV-Subdomain sichtbar */}
              {isOnCvSubdomain && (
                <Link 
                  href="#" 
                  className={`navigation--link no-select ${activePage === 'cv' ? 'router-link-active' : ''}`}
                  style={activePage === 'cv' ? { color: '#c69c6d' } : {}}
                  onClick={(e) => e.preventDefault()}
                >
                  CV
                </Link>
              )}
            </nav>
          </div>
        </div>
      </nav>
    </div>
  );
}